import {Storage} from '../utils/storage';

// 用户登录
export const setToken = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    console.log(data);
    commit('SET_USER_LOGIN_INFO', data);
    resolve();
  });
};

// 退出登陆
export const signOut = ({commit}) => {
  let obj = {
    token: '',
    out_time: 0,
    nick_name: '',
  }
  commit('SET_USER_LOGIN_INFO', obj);
  commit('SET_Shop_INFO', {});
  Storage.remove('pageCode');
  Storage.remove('pddPati');
  goLoginPage()
};


// 判断是否登陆
export const ChkLogin = ({commit}) => {
  return new Promise((resolve, reject) => {
    let datas = JSON.parse(localStorage.getItem('vuex'));
    if (datas) {
      // 存在token
      if (datas.token) {
        let exptime = datas.OutTime * 1000;
        let nowtime = Date.parse(new Date());
        // token的时间还未到期
        if (exptime > nowtime) {
          resolve()
        } else {
          let obj = {
            token: '',
            out_time: 0,
            nick_name: '',
          }
          commit('SET_USER_LOGIN_INFO', obj);
          goLoginPage()
        }
      } else {
        let obj = {
          token: '',
          out_time: 0,
          nick_name: '',
        }
        commit('SET_USER_LOGIN_INFO', obj);
        goLoginPage()
      }
    } else {
      let obj = {
        token: '',
        out_time: 0,
        nick_name: '',
      }
      commit('SET_USER_LOGIN_INFO', obj);
      goLoginPage()
    }
  });
};

function goLoginPage() {
  window.location.href = `${window.location.origin}/#/login`;
}

/**
 * 将图片路径转换为base64
 * file文件流
 * filename文件名
 */
export const dataURLtoBase64 = ({commit}, imgUrl) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = imgUrl;
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = function () {
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      let dataURL = canvas.toDataURL("image/png");
      resolve(dataURL.replace('/^data:image/(png|jpg);base64,/', ""));
    }
    img.onerror = function () {
      reject("The image could not be loaded.");
    }
  });
}

// 设置当前店铺信息
export const Set_Shop_Info = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    commit('SET_Shop_INFO', data);
    // Api.Api.Index.UploadImage(data).then(res=>{
    //   if(res.data.status == 1){
    //     resolve();
    //   }else{
    //     this.$Message['error']({
    //       background: true,
    //       content: res.data.msg
    //     });
    //     reject();
    //   }
    // })
  });
};

// 将图片 file转化成base64模式
export const GetBase64 = ({commit}, file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let fileResult = "";
    reader.readAsDataURL(file);
    //开始转
    reader.onload = function () {
      fileResult = reader.result;
    };
    //转 失败
    reader.onerror = function (error) {
      reject(error);
    };
    //转 结束  咱就 resolve 出去
    reader.onloadend = function () {
      resolve(fileResult);
    };
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js